import { render, staticRenderFns } from "./statusSet.vue?vue&type=template&id=112b2c1e&scoped=true&"
import script from "./statusSet.vue?vue&type=script&lang=js&"
export * from "./statusSet.vue?vue&type=script&lang=js&"
import style0 from "./statusSet.vue?vue&type=style&index=0&id=112b2c1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b2c1e",
  null
  
)

export default component.exports